<template>
    <div>
        <v-dialog v-model="ratingdialog" max-width="900px">
          <v-card>
            <v-card-text>
              <v-container>
                    <v-row>
                        <span style="font-weight: bold;" class="mb-2 mt-6">
                            {{$t('performancemanagement.editkpifor')}}
                            <span class="page_title_value pl-1">
                                {{ formData.goal }}
                            </span>
                        </span>
                    </v-row>

                    <div>
                        <v-row class="pb-n4 mb-2 mt-0">
                            <v-col cols="5" class="ml-0 pl-0">
                                <v-text-field
                                    outlined
                                    :label="$t('columns.type')"
                                    type="text"
                                    ref="type"
                                    :rules="[rules.required]"
                                    v-model="selections.type"
                                    dense
                                    readonly
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="5" class="ml-0 pl-0"></v-col>

                            <v-col cols="2">
                                <v-text-field
                                    outlined
                                    :label="$t('pmreviewexercisesectioncard.weightage')"
                                    type="text"
                                    :rules="[rules.required]"
                                    v-model="selections.weightage"
                                    dense
                                    class="v-input"
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <div class="mr-3">
                            <v-row class="pb-n4 mt-n7">
                                <v-text-field
                                    outlined
                                    :label="$t('pmreviewexercisesectioncard.goal')"
                                    type="text"
                                    :rules="[rules.required]"
                                    v-model="selections.goal"
                                    dense
                                    class="v-input"
                                ></v-text-field>
                            </v-row>
                            <v-row class="pb-n4 mt-n3">
                                <v-text-field
                                    outlined
                                    :label="$t('pmreviewexercisesectioncard.KPI')"
                                    type="text"
                                    :rules="[rules.required]"
                                    v-model="selections.kpi"
                                    dense
                                    class="v-input"
                                ></v-text-field>
                            </v-row>
                            <v-row class="pb-n4 mt-n6">
                                <v-col cols="4" class="pl-0">
                                    <v-autocomplete
                                        outlined
                                        :label="$t('performancemanagement.targetoption')"
                                        type="text"
                                        ref="pmtargetoptionid"
                                        :rules="[rules.required]"
                                        v-model="selections.pmtargetoptionid"
                                        @change="changeTargetOption(selections.pmtargetoptionid, 2)"
                                        dense
                                        :items="targetOptionList"
                                    ></v-autocomplete>
                                </v-col>
                                <v-col cols="4" class="pl-0">
                                    <v-autocomplete
                                        outlined
                                        :label="$t('pmassementrecord.pmassessmentcalculationmethod')"
                                        type="text"
                                        ref="pmcalmethodid"
                                        :rules="[rules.required]"
                                        v-model="selections.pmcalmethodid"
                                        dense
                                        :items="calculationMethodList"
                                    ></v-autocomplete>
                                </v-col>
                            </v-row>
                            <v-row class="pb-n4 mt-n8">
                                <v-col cols="6" class="mx-0">
                                    <v-row>
                                        <v-col v-if="selections.targetType !== 'Target Only'" cols="4" class="pl-0">
                                            <v-text-field
                                                outlined
                                                :label="$t('pmreviewexercisesectioncard.threshold')"
                                                type="text"
                                                :rules="[rules.required]"
                                                v-model="selections.threshold"
                                                dense
                                                class="v-input"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="4" class="pl-0">
                                            <v-text-field
                                                outlined
                                                :label="$t('columns.target')"
                                                type="text"
                                                :rules="[rules.required]"
                                                v-model="selections.target"
                                                dense
                                                class="v-input"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col v-if="selections.targetType !== 'Target Only'" cols="4" class="pl-0">
                                            <v-text-field
                                                outlined
                                                :label="$t('pmreviewexercisesectioncard.stretch')"
                                                type="text"
                                                :rules="[rules.required]"
                                                v-model="selections.stretch"
                                                dense
                                                class="v-input"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </div>
                    </div>
              </v-container>
            </v-card-text>

            <v-card-text v-if="isErr" class="mt-n12">
                <span style="font-weight: bold; color: red">{{errMsg}}</span>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="yellow darken-1" text @click="deleteHandler">{{$t('button.delete')}}</v-btn>
              <v-btn color="green darken-1" text @click="saveHandler">{{$t('button.save')}}</v-btn>
              <v-btn color="red darken-1" text @click="cancelHandler">{{$t('button.cancel')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <div v-if="isLoading">
            <!-- Show a loading spinner or placeholder while loading -->
            <v-progress-circular
            indeterminate
            color="primary"
            ></v-progress-circular>
        </div>

        <div v-else>
            <v-expansion-panels class="mb-4">
                <v-expansion-panel>
                <v-expansion-panel-header>
                    <v-subheader class="blue--text mt-n3 mb-n3 ml-n2">
                    {{$t('pmreviewexercisesectioncard.individualkpi')}} - {{formData.goal}} - {{$t('pmreviewexercisesectioncard.weightage')}}: {{formData.weightage}}%
                    </v-subheader>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-card>
                    <div class="ma-4 pb-1">
                        <v-row class="mt-4 ml-0">
                        <v-col cols="11" sm="11" class="pb-n5 pt-2 mt-4 ml-0 pl-0">
                            <v-col cols="3" class="pl-0 pb-0">
                            <v-text-field
                                outlined
                                :label="$t('columns.type')"
                                type="text"
                                ref="type"
                                :rules="[rules.required]"
                                v-model="formData.type"
                                dense
                                readonly
                                background-color="#ffeab2"
                            ></v-text-field>
                            </v-col>
                        </v-col>
                        <v-col cols="1" sm="1" class="pb-n5 pt-2 mt-4">
                            <v-icon
                            medium
                            class="ml-2 mr-2"
                            @click="modifyItemHandler"
                            >
                            mdi-pen
                            </v-icon>
                        </v-col>
                        </v-row>
                    </div>
                    <div class="ma-4 pb-1">
                        <v-row class="mt-n4">
                        <v-col cols="9" sm="9" class="mt-n2">
                            <v-text-field
                            outlined
                            :label="$t('pmreviewexercisesectioncard.goal')"
                            type="text"
                            ref="goal"
                            :rules="[rules.required]"
                            v-model="formData.goal"
                            dense
                            readonly
                            background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="3" sm="3" class="mt-n2">
                            <v-text-field
                            outlined
                            :label="$t('pmreviewexercisesectioncard.weightage')"
                            type="number"
                            ref="weightage"
                            :rules="[rules.required]"
                            v-model="formData.weightage"
                            dense
                            readonly
                            background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                        </v-row>

                        <v-row class="mt-n4">
                        <v-col cols="9" sm="9" class="mt-n2">
                            <v-text-field
                            class="kpi-field"
                            outlined
                            :label="$t('pmreviewexercisesectioncard.KPI')"
                            type="text"
                            ref="kpi"
                            :rules="[rules.required]"
                            v-model="formData.kpi"
                            dense
                            readonly
                            background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="3" sm="3" class="mt-n2">
                            <v-text-field
                            outlined
                            :label="$t('pmreviewexercisesectioncard.progressInPercentage')"
                            type="number"
                            ref="progress"
                            :rules="[rules.required]"
                            v-model="formData.progress"
                            dense
                            readonly
                            background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                        </v-row>

                        <v-row class="mt-n4">
                        <v-col cols="4" sm="4" class="mt-n2">
                            <v-autocomplete
                            outlined
                            :label="$t('performancemanagement.targetoption')"
                            type="text"
                            ref="pmtargetoptionid"
                            :rules="[rules.required]"
                            v-model="formData.pmtargetoptionid"
                            :items="targetOptionList"
                            dense
                            readonly
                            background-color="#ffeab2"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="4" sm="4" class="mt-n2">
                            <v-autocomplete
                            outlined
                            :label="$t('pmassementrecord.pmassessmentcalculationmethod')"
                            type="text"
                            ref="pmcalmethodid"
                            :rules="[rules.required]"
                            v-model="formData.pmcalmethodid"
                            :items="calculationMethodList"
                            dense
                            readonly
                            background-color="#ffeab2"
                            ></v-autocomplete>
                        </v-col>
                        </v-row>

                        <v-row class="mt-n4">
                            <v-col v-if="formData.targetType !== 'Target only'" cols="2" sm="2" class="mt-n2">
                                <v-text-field
                                outlined
                                :label="$t('pmreviewexercisesectioncard.threshold')"
                                type="number"
                                ref="threshold"
                                :rules="[rules.required]"
                                v-model="formData.threshold"
                                dense
                                readonly
                                background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="2" sm="2" class="mt-n2">
                                <v-text-field
                                outlined
                                :label="$t('columns.target')"
                                type="number"
                                ref="target"
                                :rules="[rules.required]"
                                v-model="formData.target"
                                dense
                                readonly
                                background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>
                            <v-col v-if="formData.targetType !== 'Target only'" cols="2" sm="2" class="mt-n2">
                                <v-text-field
                                outlined
                                :label="$t('pmreviewexercisesectioncard.stretch')"
                                type="number"
                                ref="stretch"
                                :rules="[rules.required]"
                                v-model="formData.stretch"
                                dense
                                readonly
                                background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row class="mt-4 ml-6">
                                <v-row class="blue--text">
                                    <span style="align-content: center;" > {{ $t('pmreviewexercisesectioncard.progressreview') }}</span>
                                    <v-btn class="ml-5" color="primary" dark @click="openProgressReview">+</v-btn>
                                </v-row>
                        </v-row>

                        <!--Action for Progress Review, Progress Review Dialog-->
                        <v-row class="mt-n4 ml-0 mb-12 pb-10">
                                <app-progress-review
                                v-bind:progressDialogVisible="progreselfservicereviewdialog"
                                @update:progressDialogVisible="progreselfservicereviewdialog = $event"
                                @add-progress-review="handleAddProgressReview"
                                v-bind:parentObject="{
                                target : formData.target,
                                calcmethod : formData.pmcalmethodid,
                                indkpiid: formData.id,
                                staffid : staffid,
                                reviewerid : reviewerid,
                                basedonpercentage : formData.basedonpercentage,
                                isWizard: this.parentObject.isWizard
                                }"
                                v-on:input="addItemHandler"
                                 />
                        </v-row>

                        <!--Progress Review List and Comments-->
                        <v-row v-if="progressReviewCard" class="mb-10 mx-4 mt-n12">
                            <v-col cols="12" v-for="(item, index) in progressReviewList" :key="index" class="mx-4">
                                <app-comments-card
                                    @reload-progress-review-ind="reloadProgressReviewIndividual"
                                    @edit-progress-review="editProgressReview"
                                    :key="reloadKey"
                                    style="width: 100%;"
                                    v-bind:parentObject="{
                                        progressReviewData: item,
                                        staffid : staffid,
                                        indKpiData : formData,
                                    }"
                                    v-on:input="addItemHandler"
                                />
                            </v-col>
                        </v-row>
                    </div>
                    </v-card>
                </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </div>

        <div v-if="isErr">  
            <app-error
                v-bind:parentError="{
                data: this.errMsg,
                isErr: this.isErr,
                }"
                v-on:closeError="isErr = $event"
            />
        </div>
    </div>
</template>

<script>
import ErrorDialog from "../../../components/common/ErrorDialog";
import ProgressReviewIndividual from "./ProgressReviewIndividual";
import KPICommentsCard from "./KPICommentsCard";
import moment from "moment";

export default {
    props: {
        parentObject: Object
    },

    components: {
        "app-progress-review": ProgressReviewIndividual,
        "app-comments-card": KPICommentsCard,
        "app-error": ErrorDialog,
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
            },

            //Read-only
            formData: {
                ...this.parentObject.formData,
                type: "Individual",
                targetType: null,
                userid: this.$store.getters.userId,
                progress: this.parentObject.formData.progress || 0, 
            },

            //Edit
            selections: {
                ...this.parentObject.formData,
                type: "Individual",
                targetType: null,
                userid: this.$store.getters.userId,
                progress: this.parentObject.formData.progress || 0, 
            },

            reloadKey: 0, // 🔄 Used to force reactivity after delete

            targetOptionFull: [],
            targetOptionList: [],
            calculationMethodList: [],
            isLoading: true,

            progreselfservicereviewdialog: false,
            staffid: this.parentObject.staffid,
            reviewerid: this.parentObject.reviewerid,
            progressReviewList: [],
            progressReviewCard: false,

            ratingdialog: false,
            item: this.parentObject.item,
         
            //error msg and dialog, check for duplicates vars
            isExisting: false,
            isErr: false,
            // isEditCommonKPI: false,
            errMsg: '',
        }
    },

    methods: {
        openProgressReview() {
            this.progreselfservicereviewdialog = true;
        },
 
        reloadProgressReviewIndividual() {
            this.loadProgressReviewList();
            this.reloadKey++; // force update
        },

        editProgressReview(progressReviewData) { // Normally, edit only happens when progress review is generated
            const index = this.progressReviewList.findIndex(item => item.id === progressReviewData.id);

            if (index !== -1) {
                // Merge old and new data — only updating fields present in progressReviewData
                this.progressReviewList[index] = {
                    ...this.progressReviewList[index], // existing data
                    ...progressReviewData              // new data overwrites only what's present
                };
            }

            if (this.formData.pmkpifinalscorecalmethodid == 1){ //Average
                // count all the existing progress reviews with isGenerated == 1
                // calculate the average and update the progress
        
                const generatedReviews = this.progressReviewList.filter(item => item.isGenerated === 1);
                if (generatedReviews.length > 0) {
                    const totalProgress = generatedReviews.reduce((sum, item) => sum + item.progress, 0);
                    this.formData.progress = totalProgress / generatedReviews.length;
                } 
            } else if (this.formData.pmkpifinalscorecalmethodid == 2){ //Take Last
                //if calculation = take last 
                //check between review dates and update progress
                const latestReview = this.progressReviewList
                    .filter(item => item.isGenerated === 1)
                    .reduce((latest, item) => {
                        return (!latest || (item.reviewdate && item.reviewdate > latest.reviewdate)) ? item : latest;
                    }, null);
                if (latestReview) {
                    this.formData.progress = latestReview.progress;
                }
            }
        },

        handleAddProgressReview(newData) { 
            this.loadProgressReviewList();
            this.formData.progress = newData.progress; 
        },

        loadTargetOptionListHandler() {
            return new Promise((resolve) => {
                const vm = this;

                this.$store.dispatch('get', { url: '/kpitargetoption/all' })
                .then((res) => {

                    vm.targetOptionFull = res.data.rec;

                    for (let i = 0; i < res.data.rec.length; i++) {
                        
                        vm.targetOptionList.push({
                            text: res.data.rec[i].targetoption,
                            value: res.data.rec[i].id,
                        });
                    }

                    resolve();
                })
                .catch((err) => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
                });
            });
        },

        changeTargetOption(id, selection) {
            let item = this.targetOptionFull.find((item) => item.id === id);
            if (selection == 1) {
                this.formData.targetType = item.targetoption;
            } else if (selection == 2) {
                this.selections.targetType = item.targetoption;
            }
            if (id == 1) //Target only
            {
                this.selections.threshold = null;
                this.selections.stretch = null;
            }
        },

        loadCalculationMethodListHandler() {
            return new Promise((resolve) => {

                const vm = this;
                this.$store.dispatch('get', { url: '/kpicalculationmethod/all' })
                .then((res) => {
                    for (let i = 0; i < res.data.rec.length; i++) {
                        vm.calculationMethodList.push({
                            text: res.data.rec[i].calmethod,
                            value: res.data.rec[i].id,
                        });
                    }
                    resolve();
                })
                .catch((err) => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
                });
            });

        },

       modifyItemHandler() {
            this.ratingdialog = true;
        },

        saveHandler() {
            const vm = this;

            if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
                return false;
            }

            this.$store.dispatch('put', {url: "/kpiindividual/" + vm.selections.id, payload: vm.selections})
            .then((res) => {
                if (res.data.error) {
                    vm.isErr = true;
                    if (Array.isArray(res.data.error)) {
                        vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                    } else {
                        vm.errMsg = res.data.error;
                    }
                } else {
                    this.formData = { ...this.selections };
                    this.ratingdialog = false;
                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err.message || err;
            });
        },

        deleteHandler() {
            const vm = this;

            if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
                return false;
            }
            if (confirm(this.$t('performancemanagement.deleteindividualkpi', { code: this.formData.goal }))) {
                this.$store
                .dispatch('delete', { url: "/kpiindividual/indkpi/" + this.formData.id })
                .then((res) => {
                    if (res.data.error) {
                        vm.isErr = true;
                        if (Array.isArray(res.data.error)) {
                            vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                        } else {
                            vm.errMsg = res.data.error;
                        }
                        this.resetSelections();
                        this.ratingdialog = false;
                    } else {
                        this.ratingdialog = false;
                        vm.$emit('reload-individual-kpi'); 
                    }
                })
                .catch((err) => {
                    vm.isErr = true;
                    vm.errMsg = err.message || err;
                });
            }
        },

        loadProgressReviewList() {
            const vm = this;

            this.$store.dispatch('get', { url: "/kpiindividual/progressreview/" + vm.formData.id })
            .then((res) => {
                vm.progressReviewList = res.data.rec;
                if (vm.progressReviewList.length > 0) {
                    vm.progressReviewCard = true;
                }
                vm.progressReviewList.forEach(item => {
                    if (item.reviewdate) {
                        item.reviewdate = moment(item.reviewdate).format('YYYY-MM-DD');
                    }
                });
            }).catch((err) => {
                console.error(err);
            });
        },

        cancelHandler() {
            this.ratingdialog = false;
            this.isErr = false;
            this.isExisting = false;
            this.modify = false;

            // reset the form fields
            this.resetSelections();
        },

        resetSelections() {
            this.selections = { ...this.formData };
        },          
    },

    mounted() {
        console.log('formData', this.formData);
        Promise.all([
            this.loadTargetOptionListHandler(),
            this.loadCalculationMethodListHandler(),
            this.loadProgressReviewList()
        ])
        .then(() => {
            // Both handlers have completed
            this.changeTargetOption(this.formData.pmtargetoptionid, 1);
            this.changeTargetOption(this.selections.pmtargetoptionid, 2);
            this.isLoading = false; // Set isLoading to false to display the content
        })
        .catch(err => {
            console.error('Error loading data:', err);
            this.isLoading = false; // Ensure the content shows even if there's an error
        });
    }
}
</script>

<style scoped>

.v-input .v-input__control .v-input__slot .v-text-field__slot input::-webkit-outer-spin-button,
.v-input .v-input__control .v-input__slot .v-text-field__slot input::-webkit-inner-spin-button
{
-webkit-appearance: none;
margin: 0;
}

.mdi-delete::before {
    margin-top: -8px;
}

.mdi-pen::before {
  margin-top: 20px;
  margin-left: 50px;
}

.v-icon.v-icon::after {
    background-color: transparent !important;
}
</style>